// 若未从主站获取到 window.t 则返回原参数
(function compatible() {
  if (!window.t) {
    window.t = (params) => params;
    window.lang = 'zh';
  }
})();
